import React, { useContext } from "react";
import {LangCtx} from "../../../lib/context";

const MySchedules = (props) => {
    const {l} = useContext(LangCtx);
    return (
        <div className="tabContent">
            {/* <div className="nodataBlock mrgnT">
                <div className="ndIconBox">
                    <img src="/images/icons/no-schedule.png" alt="no-schedule-icon" />
                </div>
                <h2 className="nodataHdng">No MY Schedule</h2>
                <span className="txtMd txtCenter">Create new a schedule by selecting date and days, and add slots to them.</span>
            </div> */}
            <div className="calanderCard">

            </div>
            {/* SCHEDUEL LIST */}
            <div className="listContainer">
                <div className="shedListGroup">
                    <div className="shedListItem">
                        <div className="shedListHdr">
                            <div className="hdrItem">
                                <div className="scrlBox">
                                    <div className="dayBox">
                                        <span>{l.mon}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="hdrItem childRight">
                                <span>12/10/2020 - 26/10/2020</span>
                            </div>
                        </div>

                        <div className="inputCardBlock">
                            <div className="listAutoUL">
                                <div className="listAutoAvtr Md primarySL">
                                    <span>TS</span>
                                </div>
                                <div className="listAutoContent">
                                    <span className="listTxtL">10:00 AM - 10:15 AM</span>
                                    <span className="listTxtM">{l.duration}: <small>15 mins</small></span>
                                    <span className="listTxtM">{l.label}: <small>Morning</small></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}
export default MySchedules;